/* istanbul ignore file */
import { DropDownFilter, useFilterContext, BaseFilterProps } from 'framework/list';
import { useState, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { useShowContext } from 'framework/show';
import {
  usePerformanceMeasurementService,
  type AvailableLocationToQualification,
} from 'domain/shared/performanceMeasurement';
import { useAsyncValue } from 'framework/utils';
import { Dropdown } from 'framework/form';
import { useOfficeService } from 'domain/shared/employee';

const PerformanceMeasurementOfficeFilter = ({
  source,
  competencyLevelSource,
  options: externalOptions,
  positionSource,
  ...props
}: BaseFilterProps & {
  label: string;
  competencyLevelSource: string;
  options?: AvailableLocationToQualification;
  positionSource?: string;
  isVisible?: boolean;
}) => {
  const { filters, clearAndApplyFilter } = useFilterContext();
  const [filterStyles, setFilterStyles] = useState({});
  const { data } = useShowContext();
  const { getOfficeLocationOptions } = usePerformanceMeasurementService();
  const { findAll: findAllOffices } = useOfficeService();
  const offices = useAsyncValue(findAllOffices);
  const availableLocationsToQualification = data?.availableLocationsToQualification;
  const availableQualificationToLocation = data?.availableQualificationToLocation;
  const positionFilter = positionSource && filters[positionSource];
  const position = positionFilter ? positionFilter.in?.[0] : null;
  const competencyLevelFilter = filters[competencyLevelSource];
  const competencyLevel = competencyLevelFilter ? competencyLevelFilter.in?.[0] : null;
  const isCompetencyLevelFilterActive = competencyLevel || false;
  const locationFilter = filters[source];
  const selectedOfficeId = locationFilter ? locationFilter?.in?.[0] : null;
  const availableLocationToQualification = useMemo(
    () =>
      getOfficeLocationOptions(
        offices,
        availableLocationsToQualification,
        availableQualificationToLocation,
        competencyLevel || undefined,
      ),
    [
      availableLocationsToQualification,
      availableQualificationToLocation,
      competencyLevel,
      offices,
      getOfficeLocationOptions,
    ],
  );

  useEffect(() => {
    if (position && selectedOfficeId) {
      clearAndApplyFilter(source);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position]);

  useEffect(() => {
    if (!isCompetencyLevelFilterActive) {
      setFilterStyles({
        '& .filters-reset-btn': {
          display: 'none',
        },
      });
    } else {
      setFilterStyles({});
    }
  }, [filters, isCompetencyLevelFilterActive]);

  return (
    <Box sx={filterStyles}>
      <DropDownFilter {...props} source={source} isSingle>
        <Dropdown source={source} options={availableLocationToQualification || []} {...props} />
      </DropDownFilter>
    </Box>
  );
};

export default PerformanceMeasurementOfficeFilter;
